import React from "react";
import Grid from "@mui/material/Grid";
import "../components/scss/Batumi.scss";
import campingList from "./campingList.json";

// const foundCity = ruka.find((item) => item.cityName === city);

function BatumiBeach({ dataId }) {
  return (
    <Grid container maxWidth="xl" className="wrapper">
      {campingList
        .filter((item) => item.id === dataId)
        .map((camping) => (
          <Grid item xs={20} md={20}>
            <Grid item xs={20} md={20}>
              <img
                src={camping.secoundImg}
                alt={camping.name}
                className="image"
              />
            </Grid>
            <h2>{camping.heading}</h2>
            <p>{camping.intro1}</p>
            <h2>{camping.heading2}</h2>
            <p>{camping.intro2}</p>
          </Grid>
        ))}
    </Grid>
  );
}

export default BatumiBeach;
